module.exports = __webpack_public_path__ + "static/img/sx_dsp.0c8b128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sx_dsp.png
// module id = mMTH
// module chunks = 167